import React from "react";
import "./MarketingBudget.css";

export const MarketingBudget = (props) => {
  const handleClick = (e) => {
    props.sendData(4);
    props.setBudgetSelect(e.target.value);
  };
  const marketingBudget_items = [
    {
      mr_name: "0-10k",
      mr_lable: "$0 - $10,000",
    },
    {
      mr_name: "10k-20k",
      mr_lable: "$10,000 - $20,000",
    },
    {
      mr_name: "20k-30k",
      mr_lable: "$20,000 - $30,000",
    },
    {
      mr_name: "30k+",
      mr_lable: "$30,000 +",
    },
  ];
  return (
    <>
      <h1 className="heading_text mt-5">متوسط الدخل الشهري الحالي لمشروعك :</h1>
      <span className="marketing_text">اختار من التالي : </span>
      <div className="option_container mt-5">
        {marketingBudget_items.map((res, index) => {
          return (
            <span className="budget_options" key={index}>
              <input
                type="radio"
                name="budget_name"
                id={res.mr_name}
                value={res.mr_name}
                checked={props.budgetOptios === res.mr_name ? true : false}
                className="d-none budget_input"
                onChange={handleClick}
              />
              <label htmlFor={res.mr_name} className="budget_label">
                {res.mr_lable}
              </label>
            </span>
          );
        })}
      </div>
    </>
  );
};
